import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
// import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import useFetch from 'use-http';
import _ from 'lodash';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import TsdiClient from 'src/models/AP/Client';
import TsdiSubcode from 'src/models/AP/Subcode';
import TsdiAltOrSubcodeBilling from 'src/models/AP/AltOrSubcodeBilling';

interface IFindSubCodeDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onCancel?: () => void;
    onAddNewProject?: (payload: ProspectDetails) => void;
    resetProjectSearchOptions?: () => void;
    setProjectSearchTerm?: (keyword: string) => void;
    incrementProjects?: () => void;
    subcodes?: Array<TsdiSubcode>;
    setSelectedProject?: (project: ProspectDetails) => void;
    setSelectedClient?: (project: TsdiClient) => void;
    setSelectedSubcode?: (subCode: TsdiSubcode) => void;
    style?: React.CSSProperties;
    addNewSubcode?: boolean;
    defaultProject?: number;
    mileageRate?: number;
    dayRate?: number;
    client?: TsdiClient;
    project?: ProspectDetails;
    subcodeTypes?: { value: number | string, label: string}[];
}

const FindSubcodeDialog = (props: IFindSubCodeDialogProps) => {
    const { register, errors, getValues, setError, handleSubmit } = useForm();
    const [fetchNextProjectsPage, setFetchNextProjectsPage] = useState<boolean>(true);
    const [addMode, setAddMode] = useState<boolean>(false);
    const [subcodeSearchOptions, setSubcodeSearchOptions] = useState<ODataOptions>(undefined);
    const [subcodeSearchTerm, setSubcodeSearchTerm] = useState<string>('');
    const [subcodes, setSubcodes] = useState<Array<TsdiSubcode>>(undefined);
    const [projects, setProjects] = useState<Array<ProspectDetails>>(undefined);
    const [selectedProject, setSelectedProject] = useState<number>(null);
    const { get, post, response } = useFetch();
    const paged: boolean = false;
    // const dispatch = useDispatch();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!props?.client) {
            console.log('client acquired');
        }
    }, [props?.client]);

    useEffect(() => {
        if (!!props?.project) {
            getSubCodes();
        }
    }, [props?.project]);

    useEffect(() => {
        if (!!props?.subcodeTypes && props.subcodes?.length > 0) {
            setSubcodes(props.subcodes);
        }
    }, [props?.subcodes]);

    useEffect(() => {
        if (props?.addNewSubcode !== undefined) {
            setAddMode(props?.addNewSubcode);
        }
    }, [props?.addNewSubcode]);

    useEffect(() => {
        if (!!subcodeSearchOptions) {
            getSubCodes();
        }
    }, [subcodeSearchOptions]);

    useEffect(() => {
        if ((!!subcodeSearchTerm || subcodeSearchTerm === '') && !!subcodeSearchOptions) {
            resetSubcodeSearchOptions();
        }
    }, [subcodeSearchTerm]);

    const onCreate = () => {        
        initializeClientSearchSettings();
    };

    const resetState = () => {
        setSelectedProject(!!props?.defaultProject ? props?.defaultProject : 1);
        setSubcodeSearchTerm('');
        resetSubcodeSearchOptions();
        setProjects([]);
    };

    const OKClicked = () => {
        const formData = getValues();
        props.setSelectedProject(projects[selectedProject]);
        if (!!formData?.searchClientNumber) {
            props.setSelectedClient(formData.searchClientNumber);
        }
        props.hideDialog();
        resetState();
    };

    const onSubcodeSearchChanged = (searchContent: string) => {
        search();
    };

    const onCancel = () => {
        props.hideDialog();        
        resetState();
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 1000,
            idField: 's.[SC_ID]',
            pageNumber: 1,
            columns: []
        };
        setSubcodeSearchOptions(ODataOptions.from(tableConfig).addOrderBy('s.[SC_NO]', ODataOrderByDirection.Ascending));
    };

    const getScrollStatus = (divElement: HTMLDivElement) => {
        if (divElement && !!paged) {
            const scrollTop = divElement.scrollTop % 1 > .9 ? divElement.scrollTop : Math.round(divElement.scrollTop);
            const scrollHeight = divElement.scrollHeight;
            const clientHeight = divElement.clientHeight;

            // Check if reached the end of the list
            if (scrollTop + clientHeight >= scrollHeight) {
                incrementProjects();
                console.log('end of scroll YES');
            } else {
                console.log('end of scroll NO');
            }
        }
    };

    const incrementProjects = () => {
        if (!!fetchNextProjectsPage) {
            let newSearchOptions = _.cloneDeep(subcodeSearchOptions);
            newSearchOptions.incrementPageNumber();
            setSubcodeSearchOptions(newSearchOptions);
        }
    };

    const selectSubcodeAndClose = (subcode: TsdiSubcode) => {
        props.setSelectedSubcode(subcode);
        props.hideDialog();
        resetState();
    };

    const resetSubcodeSearchOptions = () => {
        setFetchNextProjectsPage(true);
        console.log(fetchNextProjectsPage);
        let newProjectSearchOptions = _.cloneDeep(subcodeSearchOptions);
        newProjectSearchOptions.clearFilters();
        newProjectSearchOptions.addPaging(1, 1000);
        const projectId = !!props?.project?.id ? props?.project?.id : 0;
        if (!projectId) {
            return;
        }
        newProjectSearchOptions.addFilter(new ODataFilter('s.[PR_ID]', ODataFilterOperators.Equals, projectId));
        if (typeof subcodeSearchTerm === 'string') {
            const fieldValues = subcodeSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0])) && fieldValues[0] !== ' ' && fieldValues[0]?.length > 0) {
                newProjectSearchOptions.addFilter(new ODataFilter('s.[SC_NO]', ODataFilterOperators.Equals, !!subcodeSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined && fieldValues[1]?.length > 0 && fieldValues[1] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('s.[SECT_NAME]', ODataFilterOperators.Contains, !!subcodeSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined && fieldValues[2]?.length > 0 && fieldValues[2] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('s.[SECTION_TYPE]', ODataFilterOperators.Contains, !!subcodeSearchTerm ? fieldValues[2] : ''));
            }
        }
        setSubcodeSearchOptions(newProjectSearchOptions);
    };

    const getSubCodes = async () => {
        const queryString = subcodeSearchOptions?.toString();
        const projectId = props?.project?.id;
        if (projectId > 0) {
            let result = await get(`/v1.0/ClientProjectMaintenance/client/${props?.client?.clientNumber}/project/${projectId}/subcodes${queryString !== undefined ? queryString : ''}`);

            if (response.ok) {
                setSubcodes(result);
            } else {
                setSubcodes([]);
                console.log('Unable to get subcode data!');
            }
        }
    };

    const AddSubCode = async (payload: TsdiSubcode) => {
        const projectId = payload?.projectId;
        if (!!projectId) {
            let result = await post(`/v1.0/ClientProjectMaintenance/project/subcode`, payload);

            if (response.ok && result === 1) {
                getSubCodes();
                props?.hideDialog();
            } else {
                setError('AddSubCode', {
                    type: 'manual',
                    message: 'Failed to create subcode' + result,
                  });
            }
        }
    };

    const search = _.debounce(() => {
        const formData = getValues();
        const projectId = !!props?.project?.id ? props?.project?.id : 0;
        if (!projectId) {
            return;
        }
        let searchString =  (!!formData?.searchSubcodeNumber ? formData.searchSubcodeNumber : ' ');
        searchString += ',' +  (!!formData?.searchSubcodeName ? formData.searchSubcodeName : ' ');
        searchString += ',' +  (!!formData?.searchSubcodeType ? formData.searchSubcodeType : ' ');
        setSubcodeSearchTerm(searchString);
    }, 700);

    const onCreateSubcode = (formData: TsdiAltOrSubcodeBilling) => {
        const payload = getValues();
        const transformedPayload = new TsdiSubcode();
        transformedPayload.projectId = props?.project?.id;
        transformedPayload.name = payload.searchSubcodeName;
        transformedPayload.type = payload.searchSubcodeType;
        AddSubCode(transformedPayload);
    };

    return (
        <>
        <Dialog title={!!addMode ? 'Add Subcode' : 'Find Subcodes'} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ maxHeight: '75vh', width: '50%' }}>
            <form
                onSubmit={handleSubmit(onCreateSubcode)}
            >
                <div style={{display: 'inline-block', marginTop: '1rem'}}>
                    <div>
                    <RHFInputBox
                        onChange={(event) => onSubcodeSearchChanged(event.currentTarget.value)}
                        labelOnLeft={true}
                        label="Client #"
                        id={'searchClientNumber'}
                        name={'searchClientNumber'}
                        style={{width: '100px'}}
                        bodyStyle={{width: '30px'}}
                        register={register}
                        disabled={!!props.addNewSubcode ? true : false}
                        defaultVal={!!props?.client?.clientNumber ? props?.client?.clientNumber?.toString() : ''}
                    />
                    </div>
                    <RHFInputBox
                        defaultVal={props?.project?.number?.toString()}
                        onChange={(event) => onSubcodeSearchChanged(event.currentTarget.value)}
                        labelOnLeft={true}
                        label="Project #"
                        name={'searchProjectNumber'}
                        style={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline', width: '55%'}}
                        register={register}
                        disabled={!!props.addNewSubcode ? true : false}
                    />
                    <RHFInputBox
                        onChange={(event) => onSubcodeSearchChanged(event.currentTarget.value)}
                        labelOnLeft={true}
                        label="Subcode #"
                        name={'searchSubcodeNumber'}
                        style={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline', width: '55%'}}
                        register={register}
                        disabled={!!props.addNewSubcode ? true : false}
                    />
                    <RHFInputBox
                        onChange={(event) => onSubcodeSearchChanged(event.currentTarget.value)}
                        labelOnLeft={true}
                        label="Name"
                        name={'searchSubcodeName'}
                        style={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline', width: '55%'}}
                        register={register}
                    />
                    <RHFSelect
                        onChange={(event) => onSubcodeSearchChanged(event.currentTarget.value)}
                        label={`Subcode Type`}
                        name={`searchSubcodeType`}
                        defaultVal={0}
                        options={!!props?.subcodeTypes ? props.subcodeTypes : [{value: 'S', label: 'Jeffersonian' }]}
                        register={register}
                    />
                </div>
                <div style={{marginTop: '3rem', overflowY: 'hidden', maxHeight: '200px'}}>
                    {props.addNewSubcode && <div style={{fontWeight: 'bold', fontFamily: 'Arial', width: '100%', textAlign: 'center'}}>
                        Existing Subcodes
                    </div>}
                    <table>
                        <thead style={{ textAlign: 'left' }}>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Township</th>
                                <th>Range</th>
                                <th>Type</th>
                            </tr>
                        </thead>
                        <tbody onScroll={(event) => getScrollStatus(event.currentTarget)}>
                        {subcodes && subcodes?.length && subcodes?.map((subcode: TsdiSubcode, index: number) => {
                            return (
                                    // tslint:disable-next-line
                                    <tr key={subcode.number + index} onDoubleClick={() => selectSubcodeAndClose(subcode)} onClick={() => props.setSelectedSubcode(subcode) } className="table-item-hover" style={{ textAlign: 'left' }}>
                                        <td style={{ width: '7%' }}>
                                            <RHFInputBox
                                                name={`subcodeNumber`}
                                                type="text"
                                                defaultVal={subcode?.number?.toString()}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '30%' }}>
                                            <RHFInputBox
                                                name={`subcodename`}
                                                type="text"
                                                defaultVal={subcode?.name?.toString()}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            <RHFInputBox
                                                name={`township`}
                                                type="text"
                                                defaultVal={subcode?.township?.toString()}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            <RHFInputBox
                                                name={`range`}
                                                type="text"
                                                defaultVal={subcode?.range?.toString()}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            <RHFInputBox
                                                name={`subcodeType`}
                                                type="text"
                                                register={register}
                                                defaultVal={subcode?.type?.toString()}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                {/* tslint:disable-next-line: max-line-length */}
                {errors.AddSubCode && <p title={errors.AddSubCode.message} style={{color: 'red', width: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer'}}>{errors.AddSubCode.message}</p>}
                <div className="form-row" style={{marginTop: '2rem', marginLeft: '33%', textAlign: 'center'}}>
                    {!!props.addNewSubcode && <Button
                        className="blue-hover-button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'Save New Subcode'}
                        type={'submit'}
                    />}
                    {!props.addNewSubcode && <Button
                        className="blue-hover-button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'OK'}
                        onClick={() => OKClicked()}
                    />}
                    <Button
                        className="blue-hover-button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'Cancel'}
                        onClick={() => onCancel()}
                    />
                </div>
            </form>
        </Dialog>
        </>
    );
};

export default FindSubcodeDialog;



// WEBPACK FOOTER //
// ./src/components/client-project/dialogs/FindSubcodeDialog.tsx